import React from "react";

const MARK = "/brand/logo_mark.png";
const MARK_W = "/brand/logo_mark_white.png";
const FULL = "/brand/logo_full.png";
const FULL_W = "/brand/logo_white.png";

// Real MiseOne mark (knife + pan). tone="light" renders the white version for dark backgrounds.
export const LogoMark = ({ size = 31, tone = "ink", className = "" }) => (
  <img
    src={tone === "light" ? MARK_W : MARK}
    alt="MiseOne"
    style={{ height: size, width: "auto" }}
    className={className}
  />
);

// Compact nav lockup: real mark + serif "Mise One" wordmark (matches the brand logo).
export const Logo = ({ tone = "ink", className = "" }) => {
  const text = tone === "light" ? "text-white" : "text-[#1b1a18]";
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <LogoMark size={31} tone={tone} />
      <span className={`font-editorial text-2xl tracking-tight ${text}`}>Mise One</span>
    </div>
  );
};

// Full stacked logo with tagline — for the signature brand moment.
export const FullLogo = ({ tone = "ink", className = "" }) => (
  <img
    src={tone === "light" ? FULL_W : FULL}
    alt="MiseOne — The Digital Mise en Place"
    className={className}
  />
);
